import { Web3_ENV } from 'env'

const NFT_LUMIR_13W_TestNet = "0xA94fE2c2b545D8cEA6545a17EC7F67EA50540797"
const NFT_LUMIR_13W_MainNet = "0x8e52236DfcAde2Ba61A8181178610cD196a0CE56"


const NFT_LUMIR_13W = Web3_ENV === "mainnet" ? NFT_LUMIR_13W_MainNet : NFT_LUMIR_13W_TestNet

const NFT_LUMIR_13W_FUND = "0x3c2CD2e90E73fcC1801621d6B175afa56f1b128a"

export { NFT_LUMIR_13W, NFT_LUMIR_13W_FUND }